import { ApiBase } from '../api-base';
import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { EventStatisticsEntity } from './event-statistics-entity';

@inject(IHttpClient)
export class EventStatisticsApi extends ApiBase {

    constructor(http: IHttpClient) {
        super(http);
    }

    public async trackView(eventId: string): Promise<EventStatisticsEntity> {
        try {
            const response = await this.post(`api/events/${eventId}/statistics/view`, {});
            return EventStatisticsEntity.fromDto(response.content);
        } catch {
            return new EventStatisticsEntity();
        }
    }

    public async getStatistics(eventId: string): Promise<EventStatisticsEntity> {
        const response = await this.get(`api/events/${eventId}/statistics`);
        return EventStatisticsEntity.fromDto(response.content);
    }
}
